import React, { memo } from 'react';
import { Button as ButtonParallax } from '@adc/parallax-component-library';
const Button = memo(({ testID, disabled, ...rest }) => {
    return (React.createElement(ButtonParallax, { testID: disabled ? `${testID}-disabled` : `${testID}`, disabled: disabled, ...rest }));
});
Button.displayName = 'Button';
export { Button };
